
<template>
  <div class="certification" v-if="token">
    <Head :info="headInfo"></Head>
    <div class="container">
        <div class="top-box">
            <div class="top">
                <img src="../../assets/images/star.png" alt="">
                立即成为网上管家婆合伙人
                <img src="../../assets/images/star.png" alt="">
            </div>
        </div>
        <div class="form">
            <div class="name-box">
                <van-field v-model.number="tel" @input="validate()"  label="手机号" placeholder="请输入手机号" />
            </div>
            <div class="name-box">
                <van-field v-model="code" @input="validate()"  label="验证码" placeholder="请输入验证码" />
                <div class="get-code" v-if="getcodeTimer<=0" @click="getCode">获取验证码</div>
                <div class="get-code disabled" v-else>({{getcodeTimer}})S后重试</div>
            </div>
            <!-- <div class="name-box">
                <van-field v-model="licensecode" :disabled='licensecodeDisabled' @input="validate()" label="邀请码" placeholder="请输入推客码" />
            </div> -->
            <div class="btnbox"> 
                <van-button @click="register()" :disabled="disabled" round size="large" color="linear-gradient(to right, #F5251B, #FB6149)">
                立即加入
                </van-button>
            </div>
        </div>
        <div class="gjp">
            <div class="top gjp-bg">关于网上管家婆</div>
            <div class="main">
                <div class="tips">
                    <span>网上管家婆</span>
                    是任我行软件旗下的中小企业云管理平台，致力于为中小企业提供SaaS模式管理软件
                </div>
                <div class="list">
                    <div class="each">
                        <img src="../../assets/images/list1.png" alt="">
                        免安装
                    </div>
                    <div class="each">
                        <img src="../../assets/images/list2.png" alt="">
                        免维护
                    </div>
                    <div class="each">
                        <img src="../../assets/images/list3.png" alt="">
                        年付费
                    </div>
                </div>
            </div>
        </div>
        <div class="gjp">
            <div class="top tuiguang">推广产品，即可获得推广奖励</div>
            <div class="main">
                <div class="tips">
                    成为网上管家婆的合伙人，把好产品分享给好友，即
                    可获得<span>丰厚佣金奖励</span>（最高12%返佣）
                </div>
            </div>
        </div>
        <!-- <div class="gjp gjp-bottom">
            <div class="top team">发展你的团队，更高收入等着你</div>
            <div class="main">
                <div class="tips">
                    邀请好友一起推广，你可以额外获得好友推广收
                入的 <span class="text">2%</span>，和好友一起推广，建立自己的推广团队，在家就可月入过万！
                            
                </div>
            </div>
        </div> -->
    </div>
  </div>
</template>

<script type="text/babel">

import Head from '@/component_basics/Head'
import Cell from '@/component_basics/Cell'
import {ls} from '@/utils/localStorage'
import jsSha from 'jssha'
import {host} from '@/services/apiUrl.js'

// 组件
export default {
  name: 'register',
  components: {Head,Cell},
  data() {
    return {
        headInfo:{
            name: '注册',
            bg:'background:none;color:#fff'
        },
        getcodeTimer:"",   // 获取验证码倒计时
        code:"",   // 验证码
        tel:'',
        disabled:true,
        licensecode:'',
        checked:true,
        openid:'',
        token:'',
        wxInfo:{},
        licensecodeDisabled:false,
        nonceString:'',
        regs: {
            tel:/^[1][345789]\d{9}$/
        }
    };
  },

  created() {
    let _this = this
        this.licensecode = this.$route.query.code||''
        if(this.licensecode) {
            
          ls.set('licensecode',_this.licensecode||'')
        }
      if(ls.getItem('licensecode')) {
        this.licensecode = ls.getItem('licensecode')||''

      }
      if(this.licensecode) {
          this.licensecodeDisabled = true
      }
      // 微信sdk签名
        this.getWxCofig()
    //是否经过授权判断
      if(window.location.href.indexOf('token')>-1) {
          // 如果refereeId为0，则启动全量授权
        if(this.$route.query.token==''||this.$route.query.token==0) {
            this.wxauthorize()
          
        } else {
            this.token = this.$route.query.token
                ls.set('token',this.$route.query.token)
            if(this.$route.query.checked&&this.$route.query.checked!=0&&this.$route.query.checked!='0') {
                if(ls.get('redirect')) {
                    this.$router.push(ls.get('redirect'))
                    ls.del('redirect')
                } else {
                    this.$router.push('/')
                }
            } 
        }
      } else {
            this.getAppId()
      }
    // 测试环境用的接口
    // this.getToken()
  },
 mounted() {

 },
  methods: {
      getAppId() {
          this.$services.getAppId().then(res=> {
              this.wxInfo = res.data
                this.wxBaseAuthorize()
          })
      },
      validateRegister() {
        if(!this.regs.tel.test(this.tel)) {
            
          this.$toast.fail('请填写正确的手机号!');
            return false
        }
        if(!this.code) {
            
          this.$toast.fail('请填写验证码!');
            return false
        }
        return true
      },
      register() {
          let param = {
              licensecode: this.licensecode,
              tel: this.tel,
              smsYzm: this.code
            //   wxOpenid:this.openid
          }
          if(!this.validateRegister()) {
            return
          }
          this.$services.register({method:'post',data:param}).then(res=> {
              if(res.code) {
                  this.$toast.fail(res.message);
              }else {
                  ls.set('token',this.token)
                  this.$toast.success('注册成功');
                  this.$router.push({path:'/', query:{config:true}})
              }
          })
      },
      getCode() {
        
        if(!this.regs.tel.test(this.tel)) {
            
          this.$toast.fail('请填写正确的手机号!');
          return
        }
        let param={
            phone: this.tel
        }
        this.$services.getCode({
            method:"POST",
            params:param,
            type:"json"
        }).then(res=> {
            if(res.code==0) {

                this.getcodeTimer = 59
                let timer = setInterval(()=> {
                    if(this.getcodeTimer>0) {
                        this.getcodeTimer--
                    } else {
                        clearInterval(timer)
                    }
                },1000)
            } else {
                
                this.$toast.console.fail(res.message)
            }
        })
      },
      getToken() {
          this.$services.getTestToken({
            method:"POST",
            data:{refereeId:1024}
          }).then(res=>{
                    this.token = res.data
                  ls.set('token',res.data)
                  this.$toast.success('注册成功');
                  this.$router.push({path:'/', query:{config:true}})
          })
      },
      wxBaseAuthorize() {
           location.href =`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.wxInfo.appId}&redirect_uri=${encodeURIComponent(host+'/tuitui/api/weChat/baseCallBack')}&response_type=code&scope=snsapi_base&state=${encodeURIComponent(location.href.split('?')[0])}#wechat_redirect`
      },
      wxauthorize() {
          this.$services.getAppId().then(res=> {
              this.wxInfo = res.data
                // this.wxBaseAuthorize()
            location.href =`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.wxInfo.appId}&redirect_uri=${encodeURIComponent(host+'/tuitui/api/'+this.wxInfo.callBackUrl)}&response_type=code&scope=snsapi_userinfo&state=${encodeURIComponent(location.href.split('?')[0])}#wechat_redirect`
          })
      },
      getWxCofig() {
          this.$services.getConfig({method:'get',params:{type:'jsapi'}}).then(res=> {
              this.wx(res)
          })
      },
       wx(res) {
           let _this = this
            let nonce = Math.random().toString(36).substr(2, 15);
            this.nonceString = nonce 
            let time = parseInt(new Date().getTime() / 1000)
            if(window.location.href.indexOf('from') != -1 || window.location.href.indexOf('isappinstalled') != -1){
                // 二次分享url重定向 - 需要截取一次分享后微信自动拼接的url参数&from=singlemessage&isappinstalled=0
                window.location.href = window.location.href.split('?')[0]+"#"+window.location.href.split('#')[1];  // 这里的split中的字符串会变换（?或&），主要看自己的url
            }
            let str = `jsapi_ticket=${res.data}&noncestr=${nonce}&timestamp=${time}&url=${location.href.split('#')[0]}`
            let sign = new jsSha(str,'TEXT')
            console.log(time,nonce,sign.getHash('SHA-1', 'HEX'),location.href.split('#')[0])
            wx.config({
                debug:false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                timestamp: time, // 必填，生成签名的时间戳
                nonceStr: nonce, // 必填，生成签名的随机串
                signature: sign.getHash('SHA-1', 'HEX'),// 必填，签名
                jsApiList: ['onMenuShareAppMessage','onMenuShareTimeline','updateAppMessageShareData','updateTimelineShareData','onMenuShareTimeline'], // 必填，需要使用的JS接口列表
                
              });
                // wx.error(function() {
                //     alert('失败')
                // })
                wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
                    //分享朋友
                    wx.updateAppMessageShareData({ 
                      title: '网上管家婆产品', // 分享标题
                      desc: '网上管家婆云进销存，网店ERP', // 分享描述
                      link: `http://${location.host}/index.html#/register`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                      imgUrl: '', // 分享图标
                      
                    })
        })
        },
      validate() {
        if(!this.code||this.code.length!=4) {
                if(this.code.length>4) {
                    this.code= this.code.substring(0,4)
                }
                this.disabled = false
                // return false
            }
          if(/^[1][3,4,5,7,8,9][0-9]{9}$/.test(this.tel)) {
              this.disabled = false
            //   return false
          }
            
        //   return true
      }
  }
};
</script>

<style lang="less" scoped>
.certification {
    background: url('../../assets/images/register-bg.png') no-repeat;
    background-size: 100% 100%;
    padding: 15px 15px 30px 15px;
    .name-box{
        position: relative;
        .get-code{
            position: absolute;
            right: 20px;
            z-index: 100;
            top: 12px;
            color: #f7ae61;
        }
        .disabled{
            color: #918b8b;
        }
    }
}
.top-box{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    .top{
        background: url('../../assets/images/star-bg.png') no-repeat;
        background-size: 100%;
        height: 48px;
        width: 318px;
        padding: 16px;
        display: flex;
        font-size: 18px;
        color: #9A4D12;
        justify-content: center;
        align-items: center;
        img{
            width: 19px;
            height: 19px;
            margin: 0 5px;
        }
    }
}
.gjp-bottom{
    margin-bottom: 10px;
}
.gjp{
    background-color: #FFD8AF;
    border-radius: 6px;
    margin-top: 20px;
    .gjp-bg{
        background: url('../../assets/images/psi-bg.png')no-repeat;
        background-size: 100%;

    }
    .tuiguang{
        background: url('../../assets/images/tuiguang.png')no-repeat;
        background-size: 100%;

    }
    .team{
        background: url('../../assets/images/team-bg.png')no-repeat;
        background-size: 100%;
    }
    .top{
        height: 42px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 17px;
        color: #A66638;
        padding-left: 14px;
        font-weight: bold;
    }
    .main{
        padding: 20px;
        font-size: 14px;
        line-height: 26px;
        .tips{
            text-align: left;
            color: #A66638;
            span{
                color: #BD4837;
            }
            .text{
                text-decoration: underline;
            }
        }
        .list{
            display: flex;
            justify-content: space-around;
            align-items: center;
            margin-top: 20px;
            .each{
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                img{
                    width: 57px;
                    height: 57px;
                }
            }
        }
    }
}
.form{
    // padding: 16px;
    border-radius: 10px;
    margin-top: -10px;
    z-index: 2;
    position: relative;
    overflow: hidden;
    background-color: #fff;
    &>div{
        padding-left: 16px;
    }
}
</style>
